import React, { useState, useRef } from 'react';
import './ImportFile.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { downloadFileFromS3 } from 'utils/function';
import { retrieveNewFileName } from 'pages/TrafficMonitoringDetail/helpers';

const ImportFile = ({ accept, selectedFile, filename, disabled, error, onChangeFile }) => {
    const [isDragging, setIsDragging] = useState(false);
    const fileInputRef = useRef(null);

    const onDownload = async () => {
        let fileUrl = null;
        let newFilename = filename;
        if (selectedFile) {
            fileUrl = selectedFile ? URL.createObjectURL(selectedFile) : null;
            newFilename = retrieveNewFileName(selectedFile);
        } else {
            const blob = await downloadFileFromS3(`traffic_monitoring_route_data/${newFilename}`, 'blob')
            fileUrl = URL.createObjectURL(blob);
        }
        const link = document.createElement('a');
        link.href = fileUrl || '#';
        link.download = newFilename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        if (fileUrl) {
            URL.revokeObjectURL(fileUrl);
        }
    };

    const handleFileChange = (file) => {
        if (file) {
            if (onChangeFile) onChangeFile(file);
        }
    };

    const handleRemoveFile = () => {
        if (onChangeFile) onChangeFile(null);
    }

    const handleInputChange = (e) => {
        const file = e.target.files[0];
        handleFileChange(file);
        // Reset input value to allow selecting the same file again
        e.target.value = '';
    };

    const handleDragEnter = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(true);
    };

    const handleDragLeave = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(false);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };

    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(false);

        const file = e.dataTransfer.files[0];
        handleFileChange(file);
    };

    const handleButtonClick = () => {
        fileInputRef.current?.click();
    };

    const newFilename = retrieveNewFileName(selectedFile) || filename;

    return (
        <div className="import-file" style={{pointerEvents: disabled ? 'none' : 'auto', opacity: disabled ? 0.8 : 1}}>
            <div
                className={`import-file__drop-zone ${isDragging ? 'import-file__drop-zone--dragging' : ''}${error ? 'import-file__drop-zone--error' : ''}`}
                onDragEnter={handleDragEnter}
                onDragLeave={handleDragLeave}
                onDragOver={handleDragOver}
                onDrop={handleDrop}
            >
                <div className="import-file__content">
                    <p className="import-file__text">ファイルをドラッグ＆ドロップ</p>
                    <p className="import-file__text">または</p>
                    <button
                        type="button"
                        className="import-file__button"
                        onClick={handleButtonClick}
                    >
                        ファイルを選択
                    </button>
                </div>
            </div>
            <input
                ref={fileInputRef}
                type="file"
                accept={accept}
                onChange={handleInputChange}
                className="import-file__input"
                multiple={false}
            />
            {(selectedFile || filename) && (
                <div className="import-file__selected">
                    <button className='import-file__btn' onClick={onDownload} type='button'>
                        <span className="import-file__filename">{newFilename}</span>
                    </button>
                    {selectedFile && (
                        <button className='import-file__btn' type='button'
                            onClick={handleRemoveFile} title='Remove file'>
                                <FontAwesomeIcon icon={faTrash} />
                        </button>
                    )}
                </div>
            )}
            {!selectedFile && filename && (
                <span className="import-file__filename">ファイルの差し替えは、別のファイルをアップロードすることで可能です。</span>
            )}
        </div>
    );
};

export default ImportFile;
